<div class="bg"></div>
<div style="display: flex; flex-direction: column; flex-wrap: wrap; justify-items: start; align-items: center">
  <h1 class="title" style="margin-top: 5vh">Albion Online Market Tools</h1>
  <h2 class="text">Market Prices, Crafting Calculator, Farming Calculator, Black Market Flipper and Much More</h2>
  <h2 class="text" style="margin-top: 10px">Join thousands of players making smarter trades and higher profits</h2>

  <!-- MARK: Buttons -->
  <div class="line-group buttons">
    <div class="button-container">
      <button mat-fab extended color="primary" (click)="openSupportLink()" style="width: 100%">
        <div style="display: flex; align-items: center">
          <div style="height: 30px; margin-right: 10px; align-content: center">
            <mat-icon color="warn">favorite</mat-icon>
          </div>
          Subscribe to AFM
        </div>
      </button>
    </div>
  </div>
  <div class="line-group buttons">
    <div class="button-container">
      <button mat-fab extended color="primary" (click)="authService.googleSignIn()" style="width: 100%" [disabled]="authService.user$ | async">
        <div style="display: flex; align-items: center">
          <img ngSrc="assets/img/google.svg" style="margin-right: 10px" alt="Google Icon" height="20" width="20" />
          {{ (authService.user$ | async) ? "You're logged in" : 'Sign Up with Google' }}
        </div>
      </button>
    </div>
    <div class="button-container">
      <button mat-fab extended color="primary" (click)="openLink('https://www.youtube.com/@AlbionFreeMarket')" style="width: 100%">
        <div style="display: flex; align-items: center">
          <img ngSrc="assets/img/youtubeicon.webp" style="margin-right: 10px" alt="Youtube Icon" height="30" width="30" />
          YouTube Tutorials
        </div>
      </button>
    </div>
    <div class="button-container">
      <button mat-fab extended color="primary" (click)="openLink('https://discord.com/invite/BPmDE3zznH')" style="width: 100%">
        <div style="display: flex; align-items: center">
          <img ngSrc="assets/img/discordicon.webp" style="margin-right: 10px" alt="Discord Icon" height="30" width="30" />
          Join our Discord
        </div>
      </button>
    </div>
  </div>

  <!-- MARK: Numbers -->
  <div class="number-group">
    <div class="number-container">
      <div class="number">{{ afmStats()?.usersCount ? (afmStats()?.usersCount | smallNumber) : '00.0k' }}</div>
      <div class="number-text">Registered Users</div>
    </div>
    <div class="number-container">
      <div class="number">{{ afmStats()?.flipsProfit ? (afmStats()?.flipsProfit | smallNumber) : '00.0B' }}</div>
      <div class="number-text">Flipper Profit</div>
    </div>
    <div class="number-container">
      <div class="number">{{ afmStats()?.totalIncome ? ((afmStats()?.totalIncome ?? 0) - (afmStats()?.totalCost ?? 0) | smallNumber) : '0.0B' }}</div>
      <div class="number-text">Craft Profit</div>
    </div>
  </div>

  <!-- MARK: Verified Lines -->
  <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-top: 10px">
    <mat-icon color="accent" style="flex-shrink: 0; margin-right: 10px">verified</mat-icon>
    <span style="align-self: center; font-size: 1rem">Available on all 3 servers</span>
  </div>
  <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-top: 10px">
    <mat-icon color="accent" style="flex-shrink: 0; margin-right: 10px">verified</mat-icon>
    <span style="align-self: center; font-size: 1rem">Access <a href="https://www.albion-online-data.com/" target="_blank">AODP</a> market prices</span>
  </div>
  <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-top: 10px">
    <mat-icon color="accent" style="flex-shrink: 0; margin-right: 10px">verified</mat-icon>
    <span style="align-self: center; font-size: 1rem">Custom <a href="https://github.com/JPCodeCraft/AlbionDataAvalonia" target="_blank">Data Client</a> with friendly UI</span>
  </div>
  <div style="display: flex; align-items: center; flex-wrap: nowrap; margin-top: 10px">
    <mat-icon color="accent" style="flex-shrink: 0; margin-right: 10px">verified</mat-icon>
    <span style="align-self: center; font-size: 1rem">The best Albion Market Tools anywhere</span>
  </div>

  <!-- MARK: Content Creators -->
  <!-- <app-content-creators style="margin: 50px 0px"></app-content-creators> -->

  <!-- <h2 class="title" style="margin-bottom: 40px">Video Spotlight</h2>

  @if (videoUrl) {
    <iframe
      width="560"
      height="315"
      class="highlight"
      [src]="videoUrl()"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
  } -->

  <h2 class="title" style="margin-top: 50px">Silver Comes Easy</h2>
  <h3 class="text">Our tools are designed to make you rich in Albion Online</h3>

  <!-- MARK: Flipper-->
  <div class="line-group">
    <div class="image-container"><img ngSrc="assets/img/flipper.webp" alt="Black Market Flipper" class="image" fill /></div>
    <div class="lg-text">
      <h3><a routerLink="/flipper">Black Market Flipper</a></h3>
      <p>Get access to real-time market flipping information, for quick and clean profit</p>
      <p>Play it safe, buying in Caerleon and selling at the Black Market</p>
      <p>Or roll the dice and transport to the Black Market for the highest profit</p>
      <p>This is a safe and fast way of making silver in Albion Online</p>
    </div>
  </div>

  <!-- MARK: Trade Route-->
  <div class="line-group">
    <div class="lg-text">
      <h3><a routerLink="/traderoutes">Trade Routes Finder</a></h3>
      <p>Let our system show you the best trade routes around Albion Online</p>
      <p>We analyze market averages for the last 7 days, to find the best deals for you</p>
      <p>Buy low, sell high, and profit</p>
    </div>
    <div class="image-container"><img ngSrc="assets/img/traderoute.webp" alt="Trade Routes Finder" class="image" fill /></div>
  </div>

  <!-- MARK: Price check -->
  <div class="line-group">
    <div class="image-container"><img ngSrc="assets/img/pricechecker.webp" alt="Albion Online Market Prices" class="image" fill /></div>
    <div class="lg-text">
      <h3>Real-time <a routerLink="/pricecheck">Albion Market Prices</a></h3>
      <p>Get Albion market prices directly from <a href="https://www.albion-online-data.com/" target="_blank">Albion Online Data Project</a></p>
      <p>Check one or multiple items at once</p>
      <p>Save your <a routerLink="/pricefavorites">favorite prices</a> for a quick look-up</p>
    </div>
  </div>

  <!-- MARK: Craft -->
  <div class="line-group">
    <div class="lg-text">
      <h3>Craft, refine or transmute with our <a routerLink="/crafting">Albion Online crafting profit calculator</a></h3>
      <p>Albion crafting made easy with automatic price loading, precise resource return rate, automatic focus consumption calculation, food selection and much more!</p>
      <p>The most versatile crafting and refining calculator for Albion Online</p>
      <p>This is the most reliable way to get silver in Albion by crafting or refining</p>
      <p>Save your crafts and <a routerLink="/crafts">check your crafting history</a>!</p>
    </div>
    <div class="image-container"><img ngSrc="assets/img/craft.webp" alt="Crafting Calculator" class="image" fill /></div>
  </div>

  <!-- MARK: Meta -->
  <div class="line-group">
    <div class="image-container"><img ngSrc="assets/img/meta.webp" alt="Meta Items" class="image" fill /></div>
    <div class="lg-text">
      <h3>Find out the most used gears in our <a routerLink="/metaitems">Albion Online Meta Items</a> page</h3>
      <p>Filter and sort in any way you like, even KDR, to find your perfect set</p>
      <p>Gain access to our real-time PVP tracker and check server's peak hours</p>
      <p>Find the best gear to learn how to win in PVP in Albion Online</p>
    </div>
  </div>
</div>
